export enum CountryIds {
  TURKIYE = 1,
  AMERICA = 2,
  CHINA = 3,
  SPAIN = 4,
}

export enum CountryNames {
  AZERBAIJAN = 'Azərbaycan',
  TURKIYE = 'Türkiyə',
  AMERICA = 'Amerika',
  CHINA = 'Çin',
  SPAIN = 'İspaniya',
}

export enum CurrencyCodes {
  AZN = 'AZN',
  TRY = 'TRY',
  USD = 'USD',
  YEN = 'YEN',
  EURO = 'EURO',
}

export enum CurrencySymbols {
  AZN = '₼',
  TRY = '₺',
  USD = '$',
  YEN = '¥',
  EURO = '€',
}

export const COUNTRIES = {
  [CountryIds.TURKIYE]: CountryNames.TURKIYE,
  [CountryIds.AMERICA]: CountryNames.AMERICA,
  [CountryIds.CHINA]: CountryNames.CHINA,
  [CountryIds.SPAIN]: CountryNames.SPAIN,
} as const;

export const CURRENCIES = {
  [CountryIds.TURKIYE]: CurrencySymbols.TRY,
  [CountryIds.AMERICA]: CurrencySymbols.USD,
  [CountryIds.CHINA]: CurrencySymbols.USD,
  [CountryIds.SPAIN]: CurrencySymbols.EURO,
} as const;

export const COUNTRY_CONFIG = {
  [CountryIds.TURKIYE]: { name: CountryNames.TURKIYE, color: 'red' },
  [CountryIds.AMERICA]: { name: CountryNames.AMERICA, color: 'cyan' },
  [CountryIds.CHINA]: { name: CountryNames.CHINA, color: 'red' },
  [CountryIds.SPAIN]: { name: CountryNames.SPAIN, color: 'gold' },
} as const;

export type CountryId = keyof typeof COUNTRIES;
export type CountryName = typeof COUNTRIES[CountryId];

export const getCountryName = (id: CountryId | string | number | null | undefined): string => {
  if (!id) return '';
  const numericId = Number(id) as CountryId;
  return COUNTRIES[numericId] ?? '';
};

export const getCurrencySymbolByCountryId = (id: CountryId | string | number | null | undefined): string => {
  if (!id) return '';
  return CURRENCIES[Number(id) as CountryId] || CURRENCIES[CountryIds.AMERICA];
};

export const getCountryConfig = (id: CountryId | string | number | null | undefined) => {
  if (!id) return null;
  return COUNTRY_CONFIG[Number(id) as CountryIds] || null;
};
